<template>
  <div class="powered-by-footer">
    <a href="https://teamio.app" target="_blank" rel="noopener noreferrer" class="powered-by-badge">
      <span class="bolt">⚡</span>
      Powered by <strong>Teamio.app</strong>
    </a>
  </div>
</template>

<script>
export default {
  name: 'PoweredByFooter'
}
</script>

<style scoped>
.powered-by-footer {
  text-align: center;
  padding: 20px 16px 12px;
}

.powered-by-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 0.8125rem;
  color: #64748b;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.powered-by-badge:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #334155;
  text-decoration: none;
}

.bolt {
  font-size: 0.875rem;
  line-height: 1;
}

strong {
  color: #334155;
  font-weight: 600;
}
</style>
